import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { Store } from '@ngxs/store';
import { DynamicDialogRef,DialogService } from 'primeng/dynamicdialog';
import { UserState } from 'src/app/state/user/user.state';
import { SimulationLoopSettings } from '../../interfaces/simulation-loop-settings';

@Component({
  selector: 'app-loop-modal',
  templateUrl: './loop-modal.component.html',
  styleUrls: ['./loop-modal.component.scss'],
})
export class LoopModalComponent implements OnInit {
  form: FormGroup = new FormGroup({});
  model: SimulationLoopSettings = {
    numberOfIterations: 100,
    disableLoopVisualizations: false,
  };
  fields: FormlyFieldConfig[] = [];

  constructor(public ref: DynamicDialogRef, private store: Store,  private dialogService: DialogService) {}

  ngOnInit(): void {
    this.store
      .select(UserState.debuggerAccess)
      .subscribe((debuggerAccess: boolean) => {
        this.setFields(debuggerAccess);
      });
  }

  cancelLoop() {
    this.ref.close();
  }

  startLoop(model: { numberOfIterations: number}) {
    //Logic here
    this.ref.close(model);
  }

  maxIterations: number = 1000;
  setFields(debuggerAccess: boolean): void {
    this.fields = [
      {
        className: 'basin-width-100',
        key: 'numberOfIterations',
        id: 'numberOfIterations',
        type: 'textbox',
        props: {
          label: 'Number of Loops',
          type: 'number',
          placeholder: '#',
          required: true,
          max: this.maxIterations,
          min: 0,
        },
        validators: {
          loop: (c: AbstractControl, field: FormlyFieldConfig) => {
            const { max } = field.props as any
            return !(max !== undefined && c.value > max);
          },
        }
      },
      {
        className: 'basin-width-100 basin-mt-4',
        key: 'disableLoopVisualizations',
        id: 'disableLoopVisualizations',
        type: 'checkboxToggle',
        props: {
          label: 'Disable Loop Visualizations',
          required: false,
        },
        hideExpression: () => !debuggerAccess,
      },
    ];
  }



  onKeyDown(event: KeyboardEvent): void {
    if (event.key === 'Enter') {
      event.preventDefault();
      if (this.form.valid) {
        this.startLoop(this.model);
      }
    }
  }
}
